import React, { PureComponent } from 'react'
import { View, Image, Dimensions } from 'react-native'
import styled from 'styled-components/native'

import { Text } from '../../Atoms/Typography'
import Button from '../../Atoms/Button'
import PageHeader from '../../Molecules/PageHeader'
import theme from '../../../styles/theme'
import InlineError from '../../Atoms/InlineError'

import { translate } from '../../../services/translate'

const excoImages = {
  1: require('../../../assets/images/exco/exco1.jpg'),
  2: require('../../../assets/images/exco/exco2.jpg'),
  3: require('../../../assets/images/exco/exco3.jpg'),
  4: require('../../../assets/images/exco/exco4.jpg'),
  5: require('../../../assets/images/exco/exco5.jpg'),
  6: require('../../../assets/images/exco/exco6.jpg'),
  7: require('../../../assets/images/exco/exco7.jpg'),
  8: require('../../../assets/images/exco/exco8.jpg'),
  9: require('../../../assets/images/exco/exco9.jpg'),
  10: require('../../../assets/images/exco/exco10.jpg')
}

const Container = styled(View)`
  flex: 1;
  flex-direction: column;
`

const Content = styled(View)`
  height: 100%;
  flex-direction: row;
`

const Details = styled(View)`
  width: ${props => props.width}px;
  height: 100%;
  padding-left: ${theme.gutterUnit}px;
  padding-top: ${theme.gutterUnit}px;
`

const ImageContainer = styled(View)`
  border: 2px ${theme.colours.bordergrey} solid;
`

const ImageHeaderBar = styled(View)`
  position: absolute;
  height: ${props => props.height}px;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: ${theme.colours.black};
  opacity: 0.6;
`

const ImageText = styled(View)`
  position: absolute;
  height: ${props => props.height}px;
  left: 0;
  bottom: 0;
  right: 0;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-left: ${2 * theme.gutterUnit}px;
  padding-right: ${2 * theme.gutterUnit}px;
`

const OptionsBar = styled(View)`
  height: 100%;
  width: ${props => props.width}px;
  align-items: center;
  justify-content: space-between;
  border: 1px ${theme.colours.bordergrey} solid;
  margin: ${theme.gutterUnit}px;
  background-color: ${theme.colours.white};
`

const OptionsHeading = styled(View)`
  width: 100%;
  align-items: flex-start;
  justify-content: flex-start;
  background-color: ${theme.colours.grey};
  padding: ${theme.gutterUnit}px;
`

const OptionsContainer = styled(View)`
  height: 100%;
  width: 100%;
  justify-content: flex-start;
  padding: ${theme.gutterUnit}px;
`

const Option = styled(View)`
  width: 100%;
  ${props => props.index !== 0 ? `margin-top: ${2 * theme.gutterUnit}px` : ''}
`

const OptionTitle = styled(View)`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

const buttonStyle = { borderWidth: 2, borderColor: theme.colours.primary, height: 30, borderRadius: 15 }
const selectedButtonStyle = { borderColor: theme.colours.orange }

export default class ExcoDecision extends PureComponent {
  state = {
    dimensions: null
  }

  handleLayout = event => {
    if (this.state.dimensions) return // layout was already called
    const { width, height } = event.nativeEvent.layout
    this.setState({
      dimensions: { width, height }
    })
  }

  render () {
    const { id, options, name, description, error, onDecisionChange, decision, canSelect } = this.props
    const availableHeight = (Dimensions.get('window').height - theme.headerHeight - theme.teamBarHeight)
    const imageHeight = availableHeight * 0.45
    const imageHeaderHeight = imageHeight * 0.25
    const optionsWidth = this.state.dimensions ? this.state.dimensions.width / 4 : 0
    const detailsWidth = this.state.dimensions ? this.state.dimensions.width - optionsWidth : 0

    return (
      <Container>
        <PageHeader text={translate('mainMenu.excoButton', 'EXECUTIVE DECISION').toUpperCase()} />
        {!!error && (
          <InlineError message={error} />
        )}
        <Content onLayout={this.handleLayout}>
          {this.state.dimensions && (
            <>
              <Details width={detailsWidth}>
                <ImageContainer>
                  <Image
                    style={{
                      width: detailsWidth - theme.gutterUnit - 4, // 4 is border width
                      height: imageHeight,
                      resizeMode: 'cover',
                      opacity: this.imageOpacity
                    }}
                    source={excoImages[id]}
                  />
                  <ImageHeaderBar height={imageHeaderHeight} />
                  <ImageText height={imageHeaderHeight}>
                    <View>
                      <Text white size='xxl'>{String(name).toUpperCase()}</Text>
                    </View>
                  </ImageText>
                </ImageContainer>
                <Text medium size='l' overrides={{ marginTop: theme.gutterUnit, paddingLeft: theme.gutterUnit, paddingRight: theme.gutterUnit }}>BACKGROUND INFORMATION</Text>
                <Text size='s' overrides={{ padding: theme.gutterUnit, lineHeight: 28 }}>{description}</Text>
              </Details>
              <OptionsBar width={optionsWidth - (2 * theme.gutterUnit)}>
                <OptionsHeading>
                  <Text bold>OPTIONS</Text>
                  <Text size='xs' italic overrides={{ marginTop: theme.gutterUnit }}>Select one of the following options:</Text>
                </OptionsHeading>
                <OptionsContainer>
                  {options.map((o, index) => (
                    <Option key={o.id} index={index}>
                      <OptionTitle>
                        <Text bold>{o.title}</Text>
                        <Button colour={decision === o.id ? theme.colours.orange : canSelect ? theme.colours.primary : theme.colours.lightgrey} onPress={!canSelect ? null : () => onDecisionChange(o.id)} styles={[buttonStyle, decision === o.id ? selectedButtonStyle : canSelect ? { } : { borderColor: theme.colours.lightgrey }]}>
                          <Text bold={decision === o.id} colour={decision === o.id ? theme.colours.white : canSelect ? theme.colours.white : theme.colours.darkgrey}>{o.title}</Text>
                        </Button>
                      </OptionTitle>
                      <Text size='s' overrides={{ marginTop: theme.gutterUnit, lineHeight: 24 }}>{o.description}</Text>
                    </Option>
                  ))}
                </OptionsContainer>
              </OptionsBar>
            </>
          )}

        </Content>
      </Container>
    )
  }
}
